module.exports = __webpack_public_path__ + "img/mumtaz.94045103.png";